module.exports = __webpack_public_path__ + "img/np-notification.3de7c685.jpeg";